import { ref as s, computed as p, onMounted as D, nextTick as $, createBlock as w, openBlock as t, withCtx as x, createElementVNode as c, normalizeClass as r, createElementBlock as l, createCommentVNode as i, renderSlot as z, toDisplayString as j, Fragment as g, renderList as y } from "vue";
import { themeProp as B } from "../../composables/useTheme.js";
import O from "../link/link.vue.js";
import { sectionProps as C } from "../../templates/sections/mixins/useSectionProps.js";
import E from "../../templates/sections/section-single/section-single.vue.js";
/* empty css                  */
const L = {
  key: 0,
  class: "ds-grid__col ds-md-grid__col--8 ds-grid__col--12 ds-lg-grid__col--8 ds-margin-bottom-48"
}, P = ["textContent"], T = ["textContent"], W = {
  key: 1,
  class: "ds-width-full ds-display-flex ds-justify-content-center ds-align-items-center"
}, _ = { "data-j-logo": "" }, M = ["src", "alt", "loading"], I = {
  key: 0,
  class: "logo-bar__items logo-bar--slide",
  "data-j-logo-dynamic": ""
}, N = ["src", "alt", "loading"], G = {
  key: 1,
  class: "logo-bar__items logo-bar--slide"
}, R = ["src", "alt", "loading"], J = /* @__PURE__ */ Object.assign({
  name: "DsLogoBarDynamic"
}, {
  __name: "logo-dynamic",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    link: {
      type: Object,
      default: null
    },
    centered: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      required: !0
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    ...C,
    ...B
  },
  setup(e) {
    const h = e, d = s(0), u = s(0), f = s(!1), m = s(null), v = s(null), k = p(() => d.value > u.value), S = p(() => d.value < u.value);
    return D(() => {
      d.value = m.value.clientWidth + 48 * h.items.length, u.value = v.value.$el.clientWidth;
      const b = h.items.length * 4;
      m.value.style.setProperty("--logo-speed", b + "s"), $(() => {
        f.value = !0;
      });
    }), (n, b) => (t(), w(E, {
      ref_key: "parentDiv",
      ref: v,
      theme: n.theme,
      "with-space": n.withSpace,
      "with-space-top": n.withSpaceTop,
      "with-space-bottom": n.withSpaceBottom,
      "full-screen": n.fullScreen,
      "space-options-small": n.spaceOptionsSmall,
      "space-options-medium": n.spaceOptionsMedium
    }, {
      "full-screen": x(() => [
        c("div", {
          class: r(["ds-grid logo-bar", {
            "ds-justify-content-center ds-align-items-center": e.centered
          }])
        }, [
          e.title ? (t(), l("div", L, [
            z(n.$slots, "title", {}, () => [
              e.title ? (t(), l("h2", {
                key: 0,
                class: r(["ds-heading", {
                  "ds-margin-bottom-12": e.subtitle,
                  "ds-text-align-center": e.centered
                }]),
                "data-j-title": "",
                textContent: j(e.title)
              }, null, 10, P)) : i("", !0)
            ]),
            z(n.$slots, "subtitle", {}, () => [
              e.subtitle ? (t(), l("p", {
                key: 0,
                class: r(["ds-text ds-margin-top-12", { "ds-text-align-center ds-justify-content-center": e.centered }]),
                "data-j-subtitle": "",
                textContent: j(e.subtitle)
              }, null, 10, T)) : i("", !0)
            ]),
            e.link ? (t(), w(O, {
              key: 0,
              "tracking-data": { "component-name": n.$options.name, text: e.link.title, title: e.title },
              url: e.link.url,
              "lazy-url-endpoint": e.link.lazyUrlEndpoint,
              content: e.link.text,
              nuxt: e.link.nuxt,
              "open-in-new-window": e.link.openInNewWindow,
              "icon-right": { name: "chevron-right-small", category: "arrows" },
              class: r(["ds-margin-top-24", { "ds-display-flex ds-justify-content-center": e.centered }])
            }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "content", "nuxt", "open-in-new-window", "class"])) : i("", !0)
          ])) : i("", !0),
          k.value ? i("", !0) : (t(), l("div", W, [
            c("div", _, [
              (t(!0), l(g, null, y(e.items, (a, o) => (t(), l("img", {
                key: `item-${o}`,
                class: "logo-bar__image",
                src: a.src,
                alt: a.name,
                loading: a.lazy ? "lazy" : "eager"
              }, null, 8, M))), 128))
            ])
          ]))
        ], 2),
        c("div", null, [
          c("div", {
            ref_key: "logobar",
            ref: m,
            class: r(["logo-bar__wrapper", { "logo-bar--relative logo-bar--child": f.value }])
          }, [
            S.value ? i("", !0) : (t(), l("div", I, [
              (t(!0), l(g, null, y(e.items, (a, o) => (t(), l("img", {
                key: `item-${o}`,
                class: "logo-bar__image",
                src: a.src,
                alt: a.name,
                loading: a.lazy ? "lazy" : "eager"
              }, null, 8, N))), 128))
            ])),
            k.value ? (t(), l("div", G, [
              (t(!0), l(g, null, y(e.items, (a, o) => (t(), l("img", {
                key: `item-${o}`,
                class: "logo-bar__image",
                src: a.src,
                alt: a.name,
                loading: a.lazy ? "lazy" : "eager"
              }, null, 8, R))), 128))
            ])) : i("", !0)
          ], 2)
        ])
      ]),
      _: 3
    }, 8, ["theme", "with-space", "with-space-top", "with-space-bottom", "full-screen", "space-options-small", "space-options-medium"]));
  }
});
export {
  J as default
};
